import React from 'react'
import { Link } from 'react-router-dom'
import Header from './Header'
import GrowBusiness from './GrowBusiness'
import GetExtra from './GetExtra'
import MarketingCampaigns from './MarketingCampaigns'
import GetStarted from './GetStarted'
import ReachMarkets from './ReachMarkets'
import WhyItWorks from './WhyItWorks'
import SecondForm from './SecondForm'
import FAQ from './FAQ'
import Footer from './Footer'
import { Helmet } from "react-helmet-async";
import { EN_CLIENTS_PATH, EN_PROMOTE_PATH, ES_HOME_PATH } from "../routes";
import SpanishLanguageBanner from "./SpanishLanguageBanner";

const HomePage = () => {
  const handleSampleDownloadClick = () => {
    if (typeof window === "undefined") return;

    // Track in GTM-style dataLayer if available
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "sample_file_download_click",
        location: "grow_business",
        language: "en",
      });
    }

    // Track in GA-style gtag if available
    if (typeof window.gtag === "function") {
      window.gtag("event", "sample_file_download_click", {
        event_category: "engagement",
        event_label: "grow_business_en",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>How to Get Clients for Your Commercial Cleaning Business</title>
        <meta
          name="description"
          content="Learn how commercial cleaning companies consistently get clients using a proven step-by-step process and targeted commercial cleaning leads."
        />
        <link rel="alternate" hrefLang="en" href="https://www.commercialcleaningleadsforyou.com/" />
        <link rel="alternate" hrefLang="es" href={`https://www.commercialcleaningleadsforyou.com${ES_HOME_PATH}`} />
        <link rel="alternate" hrefLang="x-default" href="https://www.commercialcleaningleadsforyou.com/" />
      </Helmet>
      <SpanishLanguageBanner />
      <Header />
      <GrowBusiness onSampleDownloadClick={handleSampleDownloadClick} />
      <GetExtra />
      <MarketingCampaigns />
      <GetStarted />
      <ReachMarkets />
      <WhyItWorks />
      <SecondForm />
      <FAQ />
      {/* Related guides - English only */}
      <div className="bg-[#e8f4f6] py-6 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-[#1465B7] font-semibold text-sm uppercase tracking-wide mb-3 text-center">
            Related Guides
          </p>
          <p className="related-guides-links flex flex-wrap justify-center gap-x-4 gap-y-2 items-center text-center">
            <Link to={EN_CLIENTS_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">
              How to Get Clients for Your Commercial Cleaning Business
            </Link>
            <Link to={EN_PROMOTE_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">
              How to Promote Your Commercial Cleaning Business
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default HomePage
